/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Modal, { IInternalModalAttrs } from 'flarum/common/components/Modal';
import type Article from '../models/Article';
import type Mithril from 'mithril';

export interface ArticleBookshelfDropdownModalAttrs extends IInternalModalAttrs {
	article: Article;
}

export default class ArticleBookshelfDropdownModal extends Modal<ArticleBookshelfDropdownModalAttrs> {
	article!: Article;

	oninit(vnode: Mithril.Vnode<ArticleBookshelfDropdownModalAttrs, this>) {
		super.oninit(vnode);
		this.article = this.attrs.article;
	}

	className(): string {
		return 'ArticleBookshelfDropdownModal Modal--medium';
	}

	title(): Mithril.Children {
		return app.translator.trans('glowingblue-orell-bookshelf.forum.article_dropdown.assign_bookshelf');
	}

	content() {
		return <div className="Modal-body">{this.dropdownView()}</div>;
	}

	dropdownView() {
		return null;
	}
}
